import { render, staticRenderFns } from "./NotificationMessage.vue?vue&type=template&id=a9c12356&scoped=true"
import script from "./NotificationMessage.vue?vue&type=script&lang=js"
export * from "./NotificationMessage.vue?vue&type=script&lang=js"
import style0 from "./NotificationMessage.vue?vue&type=style&index=0&id=a9c12356&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c12356",
  null
  
)

export default component.exports